import { render } from "./StatusMaster.vue?vue&type=template&id=fcb736ba&scoped=true"
import script from "./StatusMaster.vue?vue&type=script&lang=js"
export * from "./StatusMaster.vue?vue&type=script&lang=js"

import "./StatusMaster.vue?vue&type=style&index=0&id=fcb736ba&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb736ba"]])

export default __exports__